import './article.css';
import React from 'react';
import ArticleCard from '../cards/articleCard.js';
import DocumentMeta from 'react-document-meta';
import ArticleMetaTags from './articleMetaTags.js'
class Article extends React.Component {
  constructor(props){
    super(props);
  }

  render(){
    const meta = ArticleMetaTags();

  return (
    <DocumentMeta {...meta}>
    <div>
    <div className="Article">

      <body className="Article-body">

      <div className="Article-card">
      <ArticleCard
      title=" BALANCE: Link Flooding Attack Detection and Mitigation via Hybrid-SDN "
      description= "Link Flooding Attack (LFA) is a genre of Distributed Denial
                    of Service (DDoS) attack. LFA can cut off a target area from
                    the network, without directly attacking the target.
                    The attacker chooses links which when cut off will
                    disconnect the target area and instruct the bots to flood
                    those links with small packets. Some of the existing solutions
                    are suitable for specific routing methods like shortest path
                    routing or need cooperation between Autonomous Systems (AS).
                    To overcome certain hitches of existing solutions,
                    we have proposed a novel mechanism named BALANCE.
                    It detects and mitigates LFA via hybrid-Software-Defined Network (SDN)."
      imageUrl="https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Ieee_blue.jpg/800px-Ieee_blue.jpg"
      link="https://ieeexplore.ieee.org/document/9099887"
      alt="Dev"/>
      </div>

                                            {/* Dev articles */}
                                            <div className="Article-card">
      <ArticleCard
      title=" Set up NodeJs in global path in Ubuntu with simple steps "
      description= "Set up NodeJs in global path in Ubuntu with simple steps"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/set-up-nodejs-in-global-path-in-ubuntu-with-simple-steps-3bfm"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title=" How to position items within a container using Flex Box ? "
      description= "Create a Container with items"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-to-position-items-within-a-container-using-flex-box-153o"
      alt="Dev"/>
      </div>
      <div className="Article-card">
      <ArticleCard
      title=" OpenAI Codex - The Model behind GitHub Copilot "
      description= "OpenAI has released the research paper, Evaluating Large
                    Language Models Trained on Code Which powers Codex,
                    a highly improved Autoregressive language model than the
                    3rd generation Generative Pre-trained Transformer (GPT-3)
                    language model."
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/openai-codex-the-model-behind-github-copilot-j0l"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title=" 8 categories of Git "
      description= "You can classify Git version control mechanism into 8 categories.
                    Create, Track, Revert, Update, Publish, View, Branch, Conflict.
                    Below i have given classification of git mechanism along with their important commands."
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/8-categories-of-git-2127"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title=" How to prepare custom image dataset, split as train set & test set and build a CNN model using Keras?"
      description= "Imagine you have two class of images, Class_A & Class_B.
                    Now, you need a custom dataset with train set and test set
                    for training and validation of our image data.We are going to
                    use Keras for our Dataset generation."
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-to-prepare-custom-image-dataset-split-as-train-set-test-set-and-build-a-cnn-model-using-keras-47jo"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="How a Single Mathematical question lead to the Invention of Modern Computers?"
      description= "In early 1900s German Mathematician David Hilbert put forward a question :
      is Mathematics Decidable? Which means is there an Algorithm that can
      always determine whether a statement follows the axioms?"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-a-single-mathematical-question-lead-to-the-invention-of-modern-computers-2087"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="How to do your first contribution with an Open Source project in GitHub ?"
      description= "Follow these steps"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-to-do-your-first-contribution-with-an-open-source-project-in-github-49i5"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="SQL Joins"
      description= "Inner Join, Left Join, Right Join, Full Outer Join, Left Outer Join,
                    Right Outer Join, Full Outer Join without Intersection"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/sql-joins-o3m"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="How to install Github Desktop for Ubuntu & Debian?"
      description= "Step 1 : Use the wget command followed by the URL of .deb
                    file of GitHub desktop from the shiftkey Github repo."
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-to-install-github-desktop-for-ubuntu-debian-4hko"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="How to recover our commit after a git reset --hard ?"
      description="While doing a git reset with a hard flag in any branch
                    it will reset the index and working tree which means not only
                    our index is discarded but also along with contents in our
                    working file Simply any changes to tracked files in
                    the working tree since are discarded"
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-to-recover-our-commit-after-a-git-reset-hard-14ij"
      alt="Dev"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="How classmethod in Python helps in implementing Factory methods ?"
      description="When talking about class method, it bounds to a class rather
                   than to its object. Similar to that of static method,
                   it doesn't requires the creation of the class instance.The key
                   difference between a static method and a class method is that
                   Static method knows nothing about the class and just deals with
                   the parameters while the Class method works with the class since
                   its parameter is always the class itself."
      imageUrl="https://d2fltix0v2e0sb.cloudfront.net/dev-rainbow.png"
      link="https://dev.to/danyson/how-classmethod-in-python-helps-in-implementing-factory-methods-23gl"
      alt="Dev"/>
      </div>

                                           {/* Medium articles */}
      <div className="Article-card">
      <ArticleCard
      title="Object Pool Design Pattern : Fictional Example of
              “Allocating Battle Royal Game Room to Players or vice versa” "
      description= "Have you imagined anytime of how we can allocate players to
                    a game room created in a battle royale game ?"
      imageUrl="https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png"
      link="https://danyson.medium.com/object-pool-design-pattern-fictional-example-of-allocating-battle-royal-game-room-to-players-or-933d636e4895"
      alt="Medium"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="Singleton Class in Backend design"
      description= "You might heared about singleton set in Mathematics,
                    sometimes called as Unit set, its nature is that it
                    conatins only a single element in its set."
      imageUrl="https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png"
      link="https://danyson.medium.com/singleton-class-in-backend-design-cc40ad07d157"
      alt="Medium"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="Interesting_Usages_ of_UNDERSCORE _in_SCALA"
      description= "While learning Scala i came through _ underscore symbol and
                    found initialy hard to understand its syntax but when i found
                    its usage ,i realy amazed how handy it is and how helpful
                    in easing a solution using Scala. "
      imageUrl="https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png"
      link="https://danyson.medium.com/interesting-usages-of-underscore-in-scala-402c4a4334c2"
      alt="Medium"/>
      </div>

      <div className="Article-card">
      <ArticleCard
      title="DATA CENTER TOPOLOGY DESIGN -FAT TREE"
      description= "fat tree ,a topology, which the data center hierarchy constructed on"
      imageUrl="https://miro.medium.com/max/2000/1*jfdwtvU6V6g99q3G7gq7dQ.png"
      link="https://danyson.medium.com/data-center-topology-design-fat-tree-8337f0fa04b"
      alt="Medium"/>
      </div>
      </body>
      <div className="Article-trademarks">
      <p > IEEE&copy; &nbsp; DEV&copy; &nbsp; MEDIUM&copy; &nbsp;logos are registered trademarks of those Organizations &nbsp;</p>
      <p > &copy; Copyright 2021 All rights reserved</p>
      </div>
    </div>
    </div>
    </DocumentMeta>
  );
}
}

export default Article;
